// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ng","play":"og"};